export const SubscriberStatusEnum = [
    { id: 'enabled', name: 'Enabled' },
    { id: 'disabled', name: 'Disabled' },
    { id: 'pending', name: 'Pending' },
    { id: 'sent', name: 'Sent' }
];
